export default {
  tableContainer: {
    display: 'flex',
    width: '90%',
    maxWidth: 1400,
    justifyContent: 'center',
    gap: '24px',
    margin: '40px auto 32px auto',
    minHeight: '70vh',
    flexDirection: 'column',
  },

  fileTreatment: {
    backgroundColor: 'white',
    borderRadius: 14,
    padding: 40,
    width: '100%',
    maxWidth: 1200,
    minWidth: 800,
    minHeight: 420,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    justifyContent: 'center',
  },

  highlightTitle: {
    color: '#000',
    fontWeight: 'bold',
    fontSize: '16px',
  },

  structureTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  modalTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1890ff',
    textAlign: 'center',
  },

  grid: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginTop: 8,
  },

  row: {
    display: 'flex',
    gap: 16,
    width: '100%',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },

  langCard: {
    flex: '1 1 0',
    minWidth: 260,
    maxWidth: 300,
    background: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    alignItems: 'stretch',
    padding: 12,
    boxSizing: 'border-box',
  },

  langTitle: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    fontWeight: '600',
    fontSize: 18,
    justifyContent: 'flex-start',
    color: '#000',
  },

  langTitleIcon: {
    height: 30,
    color: '#333',
  },

  langActions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  uploadBox: {
    backgroundColor: '#1890ff',
    color: 'white',
    borderRadius: 8,
    padding: '14px 18px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    width: 260,
    height: 56,
    boxSizing: 'border-box',
  },

  uploadIcon: {
    fontSize: 28,
    marginRight: 10,
    color: '#fff',
  },

  uploadText: {
    fontSize: 13,
    color: '#fff',
    fontWeight: 600,
  },

  leftActions: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
  },

  smallActions: {
    backgroundColor: '#f0f0f0ff',
    color: 'white',
    borderRadius: 8,
    padding: '0px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: '0 0 260px',
    height: 56,
    boxSizing: 'border-box',
  },

  smallActionItem: {
    display: 'flex',
    gap: 8,
    cursor: 'pointer',
    color: '#333',
    alignItems: 'center',
  },

  fileIcon: {
    marginRight: 8,
    fontSize: 18,
  },

  fileName: {
    fontSize: 15,
    color: '#333',
    flex: 1,
    maxWidth: 120,
    whiteSpace: 'nowrap',
    textAlign: 'right',
  },

  smallIcon: {
    fontSize: 22,
  },

  buttonGuide: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#fff',
    border: '1px solid #d9d9d9',
    borderRadius: '4px',
    padding: '6px 16px',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#000',
    transition: 'all 0.3s ease',
  },
};
